import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import { boltApi } from 'store/queries/bolt-api'
import { boltBackend } from 'store/queries/bolt-backend'
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { IS_PROD } from 'constants/env.ts'

// Reducers
import authReducer from 'store/auth/slice.ts'
import feedbackWidgetReducer from 'store/feedbackWidget/slice.ts'
import internalUserReducer from 'store/internalUser/slice.ts'
import producerReducer from 'store/producer/slice.ts'
import salesReducer from 'store/sales/slice.ts'
import userReducer from 'store/user/slice.ts'

const rootReducer = combineReducers({
  auth: authReducer,
  feedbackWidget: feedbackWidgetReducer,
  internalUser: internalUserReducer,
  producer: producerReducer,
  sales: salesReducer,
  user: userReducer,
  [boltApi.reducerPath]: boltApi.reducer,
  [boltBackend.reducerPath]: boltBackend.reducer
})

const persistedReducer = persistReducer(
  {
    key: 'root',
    version: 1,
    storage,
    blacklist: [boltApi.reducerPath, boltBackend.reducerPath]
  },
  rootReducer
)

export const store = configureStore({
  devTools: !IS_PROD,
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
      .concat(boltApi.middleware)
      .concat(boltBackend.middleware)
})

// Persistor for the PersistGate
export const persistor = persistStore(store)

export type RootState = ReturnType<typeof rootReducer>
export type StoreDispatch = typeof store.dispatch
